import { action } from 'easy-peasy';
import { IActionAddOrUpdateCrisisCall } from '../types';

const addOrUpdateCrisisCall: IActionAddOrUpdateCrisisCall = action((state, payload) => {
  const existingIndex = state.crisisCalls.findIndex(
    crisisCall => crisisCall.crisisCallId === payload.crisisCallId,
  );

  if (existingIndex >= 0) {
    state.crisisCalls[existingIndex] = payload;
    return;
  }

  state.crisisCalls.unshift(payload);
});

export default addOrUpdateCrisisCall;
